import {createStore, combineReducers, applyMiddleware} from 'redux';
import reducer from './reducer';
import thunkMiddleware from 'redux-thunk';

const store = createStore(
    combineReducers({app: reducer}),
    applyMiddleware(thunkMiddleware)
    //window.devToolsExtension ? window.devToolsExtension() : undefined
);

export default store;



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/